import { module } from 'modujs';
import Swiper from 'swiper';
import { Navigation } from 'swiper/modules';
import { ENV } from '../config.js';

export default class extends module {
    constructor(m) {
        super(m);
        this.minHeight = null;
    }

    init() {
        this.nbItems = this.el.querySelectorAll('.c-testi').length;
        this.swiper = new Swiper(this.el.querySelector('.swiper'), {
            slidesPerView: 1,
            spaceBetween: 10,
            allowTouchMove: ENV.IS_TOUCH,
            breakpoints: {
                480: {
                    slidesPerView: this.nbItems > 3 ? 3 : this.nbItems,
                    spaceBetween: 20
                },
            },
            on: {
                init: () => {
                    this.updateHeight();

                    window.addEventListener("resize",() => {
                        this.minHeight = 1;
                        this.el.querySelector('.swiper').style.setProperty('--minHeight', this.minHeight + 'px');
                        this.updateHeight();
                    });
                }
            },
            modules: [Navigation],
            navigation: {
                nextEl: this.el.querySelector('.m-testimonials-slider_nav.-next'),
                prevEl: this.el.querySelector('.m-testimonials-slider_nav.-prev'),
            }
        });
    }

    updateHeight() {
        this.el.querySelectorAll('.c-testi').forEach((elt) => {
            let b = elt.getBoundingClientRect();
            if (this.minHeight == null || this.minHeight < b.height) {
                this.minHeight = b.height;
            }
        });

        this.el.querySelector('.swiper').style.setProperty('--minHeight', this.minHeight + 'px');
    }
}
